/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_StepInputs */



/**
* | output |
* | --- |
* | "Current Step" |
*
* @param {Current_StepInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_step = /** @type {((inputs?: Current_StepInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_StepInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Étape actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktueller Schritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passo attuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущий шаг")
	if (locale === "es") return /** @type {LocalizedString} */ ("Paso actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前步骤")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のステップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान चरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Etapa atual")
	return /** @type {LocalizedString} */ ("Current Step")
});